import { Text } from '@mantine/core'

import { useCurrencyAmounts } from '@/hooks/business/useCurrencyAmounts'
import type { CoinOverall } from '@/types/coin'
import { formatMarketCap } from '@/utils/number/format'

import { useCoinsTableStore } from '../../context'

interface Props {
  coin: Pick<CoinOverall, 'usd_marketcap' | 'symbol' | 'slug'>
}

export default function MarketCapColumn({ coin }: Props) {
  const liveUsdMarketCap = useCoinsTableStore(
    state => state.liveCoinsMarket[coin.slug]?.usd_marketcap,
  )
  const marketCap = liveUsdMarketCap ?? coin.usd_marketcap

  const {
    amounts: [{ formattedValue }],
  } = useCurrencyAmounts({
    amounts: [marketCap],
    tokenSymbol: coin.symbol,
    valueFormatter: formatMarketCap,
    currencyFormatOptions: {},
  })

  return <Text variant="body1">{formattedValue}</Text>
}
